enum DistributorOrderRoutes {
  List = '/retailer-orders',
  Edit = '/retailer-orders/edit/:id',
  Add = '/retailer-orders/add',
}

export default DistributorOrderRoutes
